import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../core/auth/auth.service';
import { AuthErrors_ENUM } from '@models/mood/helpers/errors'
import { TopBarService } from 'src/app/top-bar/top-bar.service';
import { Router } from "@angular/router";

@Component({
  selector: 'restoreid-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements OnInit {
  loginForm = new FormGroup({
    loginInfo: new FormControl("", [Validators.required]),
    password: new FormControl("", [Validators.required])
  });

  constructor(
    private _authService: AuthService,
    private _topBarService: TopBarService,
    private _router: Router
  ) {
    this._topBarService.setTitle('Log in');
  }

  async ngOnInit() {
    if(this._authService._loggedIn$.value) {
      this._navigateToDashboard();
    }
  }

  submitLogin() {
    this._authService.login(this.loginInfoControl?.value!, this.passwordControl?.value!)
      .subscribe({
        next: result => {
          this._navigateToDashboard();
        },
        error: (error: HttpErrorResponse) => {
          if (error.error) {
            let errorObject = error.error as { message: string, code: AuthErrors_ENUM };

            switch (errorObject.code) {
              case AuthErrors_ENUM.UserNotFound:
              case AuthErrors_ENUM.AccountNotActive:
              case AuthErrors_ENUM.RoleNotAllowedToLogin:
                this.loginInfoControl?.setErrors({ error: errorObject.message });
                break;

              case AuthErrors_ENUM.IncorrectPassword:
                this.passwordControl?.setErrors({ error: errorObject.message });
                break;
            }

            this.loginForm.markAllAsTouched();
          }
        }
      });
  }

  private _navigateToDashboard() {
    this._router.navigate(['dashboard']);
  }

  public getErrorMessage(control: AbstractControl | null) {
    if (control!.getError("error")) {
      return control!.getError("error");
    } else {
      return "This field is required";
    }
  }

  public get loginInfoControl() {
    return this.loginForm.get('loginInfo');
  }

  public get passwordControl() {
    return this.loginForm.get('password');
  }
}
